import axios from 'axios';
import {BaseResponse} from "../../BaseResponse";
import {EtcProductRegistRequest} from "./etcProductRegistration";


export async function putEtcProductRegistration(uid : string, request: EtcProductRegistRequest) {
    const response = await axios.put<BaseResponse<boolean>>(`/basic/etc_product/${uid}`, request)
    return response.data
}